import React from "react";
import Header from "../common/Header";

function PrimaryPageContainer({
  classname,
  className,
  background,
  children,
  noChildPadding,
  transparent,
}) {
  const cx = className || classname || "";
  const bg = background || "bg-gray-200";

  return (
    <div
      className={`w-full min-h-screen ${bg} font-poppins`}
      style={{
        background: transparent
          ? "radial-gradient(120% 120% at 0% 0%, #ffd6d6 0%, rgba(255,214,214,0) 40%), radial-gradient(120% 120% at 100% 20%, #cfd3da 0%, rgba(207,211,218,0) 40%), radial-gradient(120% 120% at 20% 100%, #c8ffd3 0%, rgba(200,255,211,0) 40%), radial-gradient(120% 120% at 90% 90%, #ffe2b4 0%, rgba(255,226,180,0) 40%)"
          : undefined,
      }}
    >
      {/* MOBILE VIEW (<= md): the actual app */}
      <div
        className={`md:hidden w-full flex flex-col items-center bg-w relative ${cx}`}
      >
        <Header transparent={transparent} />
        <div className={`w-full mt-10 ${noChildPadding ? "" : "px-4"}`}>
          {children}
        </div>
      </div>

      {/* DESKTOP VIEW (>= md): block usage */}
      <div className="hidden md:flex min-h-screen items-center justify-center">
        <div className="max-w-md text-center px-6">
          <h1 className="text-2xl font-bold">Mobile Only</h1>
          <p className="mt-2 text-gray-500">
            This app is designed for phones. Please open it on a mobile device
            (or resize your window below 768px).
          </p>
          <div className="mt-6 p-4 rounded-xl border border-gray-300 bg-white text-gray-700">
            Tip: For dev/testing, use your browser’s device toolbar.
          </div>
        </div>
      </div>
    </div>
  );
}

export default PrimaryPageContainer;
